import { IconButton, Tooltip, Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { memo } from 'react';

interface ToggleDrawerButtonProps {
  isOpen: boolean; // menuDrawerWidth === 300
  openWidth?: number; // 300
  closedWidth?: number; // 52
  onToggle: () => void;
  top?: number; // px
}

const ToggleDrawerButton = memo(
  ({
    isOpen,
    openWidth = 300,
    closedWidth = 52,
    onToggle,
    top = 16,
  }: ToggleDrawerButtonProps) => {
    const label = isOpen ? '사이드바 접기' : '사이드바 펼치기';

    // 아이콘 방향(회전) + 버튼 위치(좌/우 여백)를 상태에 맞춰 전환
    return (
      <Box
        sx={{
          position: 'absolute',
          top,
          left: isOpen ? openWidth - 50 : closedWidth - 50, // 가장자리 살짝 안쪽
          transition: theme =>
            theme.transitions.create(['left'], { duration: 150 }),
          zIndex: 1100,
        }}
      >
        <Tooltip title={label} placement="right">
          <IconButton
            aria-label={label}
            size="small"
            onClick={onToggle}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onToggle();
              }
            }}
            sx={{
              bgcolor: 'background.paper',
              boxShadow: 2,
              '&:hover': { boxShadow: 4 },
              transition: theme =>
                theme.transitions.create(['transform', 'background-color'], {
                  duration: 150,
                }),
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            <ArrowForwardIosIcon fontSize="inherit" sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }
);

export default ToggleDrawerButton;
